import { Label } from "@fluentui/react";
import React from "react";
import { ITeamTypeSettingProps } from "../../../../../interfaces/teamTypeSettings/ITeamTypeSettingProps";
import ApprovalByDropdown from "../elements/approvalByDropdown/ApprovalByDropdown";
import RequestByDropdown from "../elements/requestByDropdown/RequestByDropdown";

export default function AddMembers(props: ITeamTypeSettingProps) {
	return <>
		<Label>Kan ingediend worden door</Label>

		<RequestByDropdown
			selectedKeys={props.values.settings.addMembers.requestBy}
			onChange={(option) => props.updateRequestOrApprovalBySettings("addMembers", "requestBy", option)}
		/>

		<ApprovalByDropdown
			selectedKeys={props.values.settings.addMembers.approvalBy}
			onChange={(option) => props.updateRequestOrApprovalBySettings("addMembers", "approvalBy", option)}
		/>
	</>;
}